module.exports = __webpack_public_path__ + "static/media/599.7554(21).e1ef6063.pdf";